import { style } from '@vanilla-extract/css'

export const note = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#828282',
})

export const noteIcon = style({
  paddingTop: '4px',
})

export const card = style({
  borderRadius: '16px',
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
})

export const cardHeading = style({
  fontSize: '15px',
  fontWeight: '700',
  textWrap: 'pretty',
})

export const thumbnail = style({
  position: 'relative',
})

export const image = style({
  height: 'auto',
  aspectRatio: '1 / 1',
  borderRadius: '8px',
  objectFit: 'cover',
})

export const discountLabel = style({
  position: 'absolute',
  top: '0px',
  left: '0px',
  backgroundColor: '#F43E3B',
  color: 'white',
  fontSize: '12px',
  fontWeight: '700',
  padding: '2px 8px',
  borderRadius: '8px 0',
})
